import React, { useEffect, useState } from "react";
import AboutBannerImage1 from "../../src/assets/images/dna1.png";
import AboutBannerImage2 from "../../src/assets/images/aboutbanner2.jpeg";
import AboutBannerImage3 from "../../src/assets/images/dna1.png";
import { useNavigate } from "react-router-dom";
import { getAllCourses } from "../api/api";

const FeaturedCourses = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                setLoading(true);
                const response = await getAllCourses();
                console.log("Courses API Response:", response);

                if (response && response.success === true) {
                    const mappedCourses = response.courses.map(course => ({
                        id: course.id,
                        slug: course.slug,
                        title: course.title,
                        instructor: course.instructor_name,
                        duration: course.duration_display || "Flexible",
                        rating: course.rating_display || "4.0",
                        price: course.price,
                        discounted_price: course.discounted_price,
                        price_formatted: course.price_formatted,
                        discounted_price_formatted: course.discounted_price_formatted,
                        image: course.image_url || AboutBannerImage1,
                        is_bestseller: course.is_bestseller || false,
                        has_discount: course.discounted_price && course.discounted_price < course.price
                    }));

                    setCourses(mappedCourses);
                    setError(null);
                } else {
                    console.error("Failed to load courses:", response?.message);
                    setCourses([]);
                    setError(response?.message || "No courses found");
                }
            } catch (error) {
                console.error("Error fetching courses:", error);
                setCourses([]);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);

    const handleEnrollNow = (slug) => {
        navigate(`/courses-details/${slug}`);
    };

    if (loading) {
        return (
            <div className="bg-[#f7f7f7] py-16 px-6">
                <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-[#f7f7f7] py-16 px-6">
            <div className="text-center mb-12">
                <p className="text-[#6BCB3D] text-sm font-semibold font-lato tracking-widest mb-3 uppercase">
                    Top Programs
                </p>
                <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 font-merriweather">
                    Explore Our Featured Courses
                </h2>
                <p className="text-gray-500 mt-3 font-lato mx-auto">
                    Start your journey with our most popular certification programs designed for immediate impact.
                </p>
            </div>
            {!loading && courses.length > 0 ? (
                <div className="custom-padding xl-screen-padding grid grid-cols-1 md:grid-cols-3 gap-8">
                    {courses.map((course) => (
                        <div key={course.id} className="bg-white rounded-xl shadow-md overflow-hidden">
                            <div className="relative">
                                <img
                                    src={course.image}
                                    alt={course.title}
                                    className="w-full h-48 object-cover"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = AboutBannerImage1;
                                    }}
                                />

                                {course.is_bestseller && (
                                    <span className="absolute top-3 left-3 text-xs px-3 py-1 rounded-full text-white font-lato bg-[#6dbe45]">
                                        Bestseller
                                    </span>
                                )}
                            </div>

                            <div className="p-5">
                                <div className="flex justify-between text-sm text-gray-500 mb-2 font-lato">
                                    <span>⏱ {course.duration}</span>
                                    <span>⭐ {course.rating}</span>
                                </div>
                                <h3 className="font-semibold text-gray-800 mb-2 font-lato font-bold">
                                    {course.title}
                                </h3>
                                <p className="text-sm text-gray-500 mb-4 font-lato font-bold">
                                    {course.instructor}
                                </p>
                                <div className="flex justify-between items-center font-lato">
                                    <div>
                                        {course.has_discount ? (
                                            <div className="flex items-center gap-2">
                                                <span className="text-green-600 font-bold text-lg">
                                                    {course.price_formatted}

                                                </span>
                                                <span className="text-gray-400 text-sm line-through">
                                                    {course.discounted_price_formatted}
                                                </span>
                                            </div>
                                        ) : (
                                            <span className="text-[#6dbe45] font-bold text-lg">
                                                {course.price_formatted}
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleEnrollNow(course.slug)}
                                        className="bg-[#6dbe45] hover:bg-[#5bb532] text-white text-sm px-4 py-2 rounded-xl font-lato font-bold"
                                    >
                                        Enroll Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                !loading && !error && (
                    <div className="text-center py-8">
                        <p className="text-gray-500">No courses available at the moment.</p>
                    </div>
                )
            )}
            {error && (
                <div className="text-center py-8">
                    <p className="text-red-500">Error loading courses: {error}</p>
                </div>
            )}

            {courses.length > 0 && (
                <div className="text-center mt-10">
                    <button className="border border-[#6dbe45] text-[#6dbe45] px-6 py-2 text-lg sm:text-xl font-semibold rounded-lg hover:bg-green-50 transition">
                        View All {courses.length}+ Courses
                    </button>
                </div>
            )}
        </div>
    );
};

export default FeaturedCourses;